<template>
  <section :class="$style.menu">
    <ExternalLink
      :href="FAQ_URL"
      :class="[$style.menu__link, $style.link]"
      @click="handleClickFaq"
      noIcon
    >
      よくあるご質問
    </ExternalLink>
    <RouterLink
      v-if="hasMultipleEntrances"
      :class="[$style.menu__link, $style.link]"
      :to="{ name: 'switchEntrance' }"
    >
      アカウント変更
    </RouterLink>
    <RouterLink
      :class="[$style.menu__link, $style.link]"
      :to="{ name: 'logout' }"
    >
      ログアウト
    </RouterLink>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useSettingPageSideMenuSubQuery } from './SettingsPageSideMenu.generated'
import { FAQ_URL } from '@/config'

import ExternalLink from '@/components/atoms/ExternalLink.vue'
import { useLogger } from '@/logger/logger'

const logger = useLogger()

const { result } = useSettingPageSideMenuSubQuery()
const hasMultipleEntrances = computed(
  () => (result.value?.entrances.length ?? 0) >= 2
)

const handleClickFaq = () => {
  logger.ltlPeople.event.openFAQPage(logger.buildMeta())
}
</script>

<style lang="scss" module>
.menu {
  display: flex;
  flex-direction: column;
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;
  box-shadow: $shadow-4;
}

.link {
  height: 48px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  color: $color-text-and-object-medium-emphasis;

  &:nth-child(n + 2) {
    border-top: 1px solid $color-border-low-emphasis;
  }

  &:hover {
    text-decoration: none;
    color: $color-text-and-object-accent-primary;
  }
}
</style>
